import httpClient from '../../utils/http'
import { handleResponseAsync } from '../../utils/HelperUtils'
import { normalize } from 'normalizr'
import { colorsSchema } from './../../entities/schema'
import _ from 'lodash'

export const colorsService = {
    getColors,
    updateColors,
    addColors,
    removeColorsById,
    removeColors,
}

const API_PATH = '/api/customization/colors'

function convertViewModelList(data) {
    const colorListSchema = [colorsSchema]
    const normalizedData = normalize(data, colorListSchema)
    return normalizedData.entities
}

function convertViewModel(data) {
    const normalizedData = normalize(data, colorsSchema)
    return normalizedData.entities
}

function convertById(data) {
    return data.id
}

function getColors() {
    const url = API_PATH

    // const config = {
    //     headers: {
    //         'content-type': 'application/json',
    //     },
    // }

    return httpClient
        .get(url)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function updateColors(data) {
    const url = API_PATH

    // const config = {
    //     headers: {
    //         'content-type': 'application/json',
    //     },
    // }
    return httpClient
        .put(url, data)
        .then(handleResponseAsync)
        .then(res => convertViewModel(_.first(res.data)))
}

function addColors(data) {
    const url = API_PATH

    // const config = {
    //     headers: {
    //         'content-type': 'application/json',
    //     },
    // }
    return httpClient
        .post(url, data)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function removeColorsById(id) {
    const url = `${API_PATH}/${id}`

    // const config = {
    //     headers: {
    //         'content-type': 'application/json',
    //     },
    // }
    return httpClient
        .delete(url)
        .then(handleResponseAsync)
        .then(res => convertById(res.data))
}

function removeColors(data) {
    const url = `${API_PATH}/delete`

    // const config = {
    //     headers: {
    //         'content-type': 'application/json',
    //     },
    // }
    return httpClient
        .post(url, data)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}
